// src/etapas/EtapaDetalhesImportantes.js
import React, { useState, useEffect } from 'react';
import api from '../services/api';

function EtapaDetalhesImportantes({ onNext, onBack, setDados, dados }) {
  const [usarEnderecoCliente, setUsarEnderecoCliente] = useState(false);

  const enderecoVazio = {
    cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', uf: '',
    tipoImovel: '', andar: '', acesso: ''
  };

  const [origem, setOrigem] = useState(enderecoVazio);
  const [destino, setDestino] = useState(enderecoVazio);

  // Carrega dados caso existam
  useEffect(() => {
    if (dados.etapa4?.origem) {
      setOrigem({
        cep: dados.etapa4.origem.cep || '',
        endereco: dados.etapa4.origem.logradouro || '',
        numero: dados.etapa4.origem.numero || '',
        complemento: dados.etapa4.origem.complemento || '',
        bairro: dados.etapa4.origem.bairro || '',
        cidade: dados.etapa4.origem.cidade || '',
        uf: dados.etapa4.origem.uf || '',
        tipoImovel: dados.etapa4.origem.tipoImovel || '',
        andar: dados.etapa4.origem.andar || '',
        acesso: dados.etapa4.origem.acesso || ''
      });
    }

    if (dados.etapa4?.destino) {
      setDestino({
        cep: dados.etapa4.destino.cep || '',
        endereco: dados.etapa4.destino.logradouro || '',
        numero: dados.etapa4.destino.numero || '',
        complemento: dados.etapa4.destino.complemento || '',
        bairro: dados.etapa4.destino.bairro || '',
        cidade: dados.etapa4.destino.cidade || '',
        uf: dados.etapa4.destino.uf || '',
        tipoImovel: dados.etapa4.destino.tipoImovel || '',
        andar: dados.etapa4.destino.andar || '',
        acesso: dados.etapa4.destino.acesso || ''
      });
    }

    if (dados.etapa4?.observacao) {
      setObservacao(dados.etapa4.observacao);
    }

    if (dados.etapa4?.dataServico) {
      setDataServico(dados.etapa4.dataServico);
    }

    if (dados.etapa4?.exclusividade) {
      setExclusividade(true);
    }

    if (dados.etapa4?.armazenar) {
      setArmazenar(true);
    }
  }, [dados]);


  const [observacao, setObservacao] = useState(dados.etapa4?.observacao || '');
  const [exclusividade, setExclusividade] = useState(dados.etapa4?.exclusividade || false);
  const [armazenar, setArmazenar] = useState(dados.etapa4?.armazenar || false);
  const [seguro, setSeguro] = useState(dados.etapa4?.seguro || false);
  const [pesoTotal, setPesoTotal] = useState(dados.etapa4?.pesoTotal || '');
  const tipoServico = dados.etapa3?.tipoServico?.titulo?.toLowerCase() || '';
  const [dataServico, setDataServico] = useState(dados.etapa4?.dataServico || '');
  const [datasDisponiveis, setDatasDisponiveis] = useState([]);
  const [limiteDatas, setLimiteDatas] = useState(10);

  // useEffect corrigido (ao marcar "Usar endereço do cliente")
  useEffect(() => {
    if (usarEnderecoCliente && dados.etapa1?.cliente) {
      const end = dados.etapa1.cliente.endereco || {};
      setOrigem((prev) => ({
        ...prev,
        cep: dados.etapa1.cliente.cep || end.cep || '',
        endereco: end.logradouro || '',
        numero: end.numero || '',
        complemento: end.complemento || '',
        bairro: end.bairro || '',
        cidade: end.cidade || '',
        uf: end.uf || ''
      }));
    }
  }, [usarEnderecoCliente, dados.etapa1]);

  // No carregarDatas:
  const carregarDatas = async () => {
    try {
      const hoje = new Date().toISOString().split('T')[0];
      const response = await api.get('busca/v1/disponibilidade/datas', {
        params: { inicio: hoje, limite: limiteDatas }
      });

      // Corrige fuso e salva como YYYY-MM-DD puro
      const datasCorrigidas = response.data.map((dataISO) =>
        dataISO.split('T')[0]
      );

      setDatasDisponiveis(datasCorrigidas);
    } catch (error) {
      console.error('Erro ao buscar datas disponíveis:', error);
    }
  };

  useEffect(() => {
    carregarDatas();
  }, [limiteDatas]);

  const handleChange = (e, local, setLocal) => {
    const { name, value } = e.target;
    setLocal((prev) => ({ ...prev, [name]: value }));
  };

  const camposObrigatoriosPreenchidos = (local) => {
    const obrigatorios = ['cep', 'endereco', 'numero', 'bairro', 'cidade', 'uf', 'tipoImovel'];
    for (const campo of obrigatorios) {
      if (!local[campo]) return false;
    }
    if (local.tipoImovel === 'Prédio' && (!local.andar || !local.acesso)) return false;
    return true;
  };

  const podeAvancar = () => {
    return camposObrigatoriosPreenchidos(origem) && camposObrigatoriosPreenchidos(destino) && dataServico;
  };

  // função avancar corrigida
  const avancar = () => {
    setDados((prev) => ({
      ...prev,
      etapa4: {
        origem: {
          logradouro: origem.endereco,
          numero: origem.numero,
          complemento: origem.complemento,
          bairro: origem.bairro,
          cidade: origem.cidade,
          uf: origem.uf,
          cep: origem.cep,
          tipoImovel: origem.tipoImovel,
          andar: origem.andar,
          acesso: origem.acesso
        },
        destino: {
          logradouro: destino.endereco,
          numero: destino.numero,
          complemento: destino.complemento,
          bairro: destino.bairro,
          cidade: destino.cidade,
          uf: destino.uf,
          cep: destino.cep,
          tipoImovel: destino.tipoImovel,
          andar: destino.andar,
          acesso: destino.acesso
        },
        observacao: observacao || null,
        dataServico: dataServico,
        pesoTotal: tipoServico === 'mercadoria' ? pesoTotal : null,
        exclusividade: exclusividade || false,
        armazenar: armazenar || false,
        seguro: seguro || false
      }
    }));

    console.log('Dados atualizados após etapa 4:', dados);

    onNext();
  };

  const renderEnderecoForm = (local, setLocal, label, podeUsarCliente = false) => (
    <div className="border rounded p-3 mb-4">
      <h5 className="mb-3">{label}</h5>
      {podeUsarCliente && (
        <div className="form-check mb-3">
          <input
            className="form-check-input"
            type="checkbox"
            id="usarCliente"
            checked={usarEnderecoCliente}
            onChange={() => setUsarEnderecoCliente(!usarEnderecoCliente)}
          />
          <label className="form-check-label" htmlFor="usarCliente">
            Usar endereço do cliente
          </label>
        </div>
      )}

      <div className="row g-2">
        <div className="col-md-3">
          <div className="input-group">
            <input className="form-control" name="cep" placeholder="CEP" value={local.cep} onChange={(e) => handleChange(e, local, setLocal)} />
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={label === 'Local de Origem' ? consultarCepOrigem : consultarCepDestino}
            >
              <i className="fa fa-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-6">
          <input className="form-control" name="endereco" placeholder="Endereço" value={local.endereco} onChange={(e) => handleChange(e, local, setLocal)} />
        </div>
        <div className="col-md-3">
          <input className="form-control" name="numero" placeholder="Número" value={local.numero} onChange={(e) => handleChange(e, local, setLocal)} />
        </div>
        <div className="col-md-6">
          <input className="form-control" name="complemento" placeholder="Complemento" value={local.complemento} onChange={(e) => handleChange(e, local, setLocal)} />
        </div>
        <div className="col-md-6">
          <input className="form-control" name="bairro" placeholder="Bairro" value={local.bairro} onChange={(e) => handleChange(e, local, setLocal)} />
        </div>
        <div className="col-md-6">
          <input className="form-control" name="cidade" placeholder="Cidade" value={local.cidade} onChange={(e) => handleChange(e, local, setLocal)} />
        </div>
        <div className="col-md-2">
          <input className="form-control" name="uf" placeholder="UF" value={local.uf} onChange={(e) => handleChange(e, local, setLocal)} />
        </div>
      </div>

      <div className="mt-3">
        <label>Tipo de imóvel:</label>
        <select className="form-select" name="tipoImovel" value={local.tipoImovel} onChange={(e) => handleChange(e, local, setLocal)}>
          <option value="">Selecione</option>
          <option value="Casa">Casa</option>
          <option value="Prédio">Prédio</option>
          <option value="Galpão">Galpão</option>
        </select>
      </div>

      {local.tipoImovel === 'Prédio' && (
        <div className="mt-2">
          <input className="form-control mb-2" type='number' name="andar" placeholder="Andar" value={local.andar} onChange={(e) => handleChange(e, local, setLocal)} />
          <select className="form-select" name="acesso" value={local.acesso} onChange={(e) => handleChange(e, local, setLocal)}>
            <option value="">Acesso</option>
            <option value="Escada">Escada</option>
            <option value="Elevador">Elevador</option>
            <option value="Janela">Janela</option>
          </select>
        </div>
      )}
    </div>
  );

  const consultarCepOrigem = async () => {
    try {      
      const cepLimpo = origem.cep.replace(/\D/g, "");
      if (cepLimpo.length !== 8) {
        alert("CEP inválido!");
        return;
      }

      const { data } = await api.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

      if (data.erro) {
        alert("CEP não encontrado!");
        return;
      }

      setOrigem((prev) => ({ ...prev, endereco: data.logradouro }));
      setOrigem((prev) => ({ ...prev, complemento: data.complemento }));
      setOrigem((prev) => ({ ...prev, bairro: data.bairro }));
      setOrigem((prev) => ({ ...prev, cidade: data.localidade }));
      setOrigem((prev) => ({ ...prev, uf: data.uf }));
            
    } catch (error) {
      console.error("Erro ao consultar CEP:", error);
      alert("Não foi possível buscar o CEP.");
    }
  };

  const consultarCepDestino = async () => {
    try {      
      const cepLimpo = destino.cep.replace(/\D/g, "");
      if (cepLimpo.length !== 8) {
        alert("CEP inválido!");
        return;
      }

      const { data } = await api.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);

      if (data.erro) {
        alert("CEP não encontrado!");
        return;
      }

      setDestino((prev) => ({ ...prev, endereco: data.logradouro }));
      setDestino((prev) => ({ ...prev, complemento: data.complemento }));
      setDestino((prev) => ({ ...prev, bairro: data.bairro }));
      setDestino((prev) => ({ ...prev, cidade: data.localidade }));
      setDestino((prev) => ({ ...prev, uf: data.uf }));

    } catch (error) {
      console.error("Erro ao consultar CEP:", error);
      alert("Não foi possível buscar o CEP.");
    }
  };

  return (
    <div className="container">
      <h4 className="fw-semibold text-center mb-4" style={{ fontSize: '1.5rem', color: '#444' }}>
        Detalhes Importantes do Transporte
      </h4>

      {renderEnderecoForm(origem, setOrigem, 'Local de Origem', true)}
      {renderEnderecoForm(destino, setDestino, 'Local de Destino')}

      <div className="row mb-3">
        <div className="col-md-6">
          <label className="form-label">Data desejada para o serviço:</label>
          <select className="form-select" value={dataServico} onChange={(e) => setDataServico(e.target.value)}>
            <option value="">Selecione uma data</option>
            {datasDisponiveis.map((data, idx) => {
              const [ano, mes, dia] = data.split('-');
              return (
                <option key={idx} value={data}>
                  {`${dia}/${mes}/${ano}`}
                </option>
              );
            })}
          </select>
          <div className="mt-2">
            <button className="btn btn-link btn-sm" onClick={() => setLimiteDatas((prev) => Math.max(prev - 10, 10))}>
              Carregar menos datas
            </button>
            <button className="btn btn-link btn-sm" onClick={() => { setLimiteDatas(limiteDatas + 10); carregarDatas(); }}>
              Carregar mais datas
            </button>
          </div>
        </div>

        {tipoServico === 'mercadoria' && (
          <div className="col-md-6">
            <label className="form-label">Peso Total (kg):</label>
            <input
              type="number"
              className="form-control"
              placeholder="Ex: 250"
              value={pesoTotal}
              onChange={(e) => setPesoTotal(e.target.value)}
            />
          </div>
        )}
      </div>

      <div className="row mb-4">
        <div className="col-md-4 form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="exclusivo"
            checked={exclusividade}
            onChange={() => setExclusividade(!exclusividade)}
          />
          <label className="form-check-label" htmlFor="exclusivo">
            Prestação de serviço com exclusividade
          </label>
        </div>
        <div className="col-md-4 form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="armazenar"
            checked={armazenar}
            onChange={() => setArmazenar(!armazenar)}
          />
          <label className="form-check-label" htmlFor="armazenar">
            Necessário armazenar itens após coleta
          </label>
        </div>
        <div className="col-md-4 form-check">
          <input
            className="form-check-input"
            type="checkbox"
            id="seguro"
            checked={seguro}
            onChange={() => setSeguro(!seguro)}
          />
          <label className="form-check-label" htmlFor="seguro">
            Deseja incluir seguro para os itens transportados
          </label>
        </div>
      </div>

      <div className="mb-4">
        <label>Observações:</label>
        <textarea
          className="form-control"
          rows="4"
          value={observacao}
          onChange={(e) => setObservacao(e.target.value)}
          placeholder="Ex: Melhor horário para retirada, animais no local, etc."
        />
      </div>

      <div className="d-flex justify-content-between">
        <button className="btn btn-secondary" onClick={onBack}>Voltar</button>
        <button className="btn btn-success" onClick={avancar} disabled={!podeAvancar()}>
          Avançar
        </button>
      </div>
    </div>
  );
}

export default EtapaDetalhesImportantes;
